function updateForm() {
  const form = $("#new_booking_room_form");
  const path = form.data("preflight-url");
  const data = form.serialize();
  const request = $.ajax({
    url: path,
    data,
    method: "post",
  });

  request.done(function (content) {
    const partial = ".bookingCompanion-preflight";
    diff.innerHTML(
      $(partial).get(0),
      $(content).find(partial).get(0).innerHTML,
    );
    $(document).trigger("turbo:load");
  });
}

$(document).on("change", ".js-preflight", (e) => updateForm());
